module.exports = "/_next/static/images/og-painting-image-bbf36b0b61b73d51a5df4d747715e361.jpg";